export default __webpack_public_path__ + "static/media/med-highlight.aed603d8.svg";